import { formatDate } from '../date/formatDate';
import { createFilterTitle } from './filterTitle';

const createPriceRangeLabel = (value: string) => {
  const [from, to] = value.split('.0T');
  if (to === '*') {
    return `$${Number(from)}+`;
  }
  return `$${Number(from)} - $${Number(to)}`;
};

const createSelectedRatingLabel = (value: string) => {
  const [from, to] = value.split('.0T');
  if (from.includes('5')) {
    return `${Number(from)}`;
  }
  return `${Number(from)} & Up`;
};

const createSelectedVelocityLabel = (value: string) => {
  const [from, to] = value.split('.0T');

  if (to === '*') {
    return `${Number(from)} and up`;
  }
  return `${Number(from)}-${Number(to)}`;
};

const createSelectedWeightLabel = (value: string) => {
  const [from, to] = value.split('.0T');

  if (from === '*') {
    return '1';
  }
  if (to === '*') {
    return `> ${Number(from)}`;
  }
  if (from.toLowerCase().includes('varies')) {
    return value;
  }
  return `${Number(from)} to ${Number(to)}`;
};

const createPriceFilterLabel = (value: string, count: number) => {
  const [from, to] = value.split('.0T');
  if (to === '*') {
    return `$${Number(from)}+ (${count})`;
  }
  return `$${Number(from)} - $${Number(to)} (${count})`;
};

const createRatingFilterLabel = (value: string, count: number | undefined) => {
  if (value.includes('5')) {
    return count === undefined ? `5` : `5 (${count})`;
  }
  const [from, to] = value.split('.0T');
  return count === undefined ? `${Number(from)} & Up` : `${Number(from)} & Up (${count})`;
};

const createVelocityFilterLabel = (value: string, count: number) => {
  const [from, to] = value.split('.0T');

  if (to === '*') {
    return `${Number(from)} and up (${count})`;
  }
  return `${Number(from)}-${Number(to)} (${count})`;
};

const createWeightFilterLabel = (value: string, count: number) => {
  const [from, to] = value.split('.0T');

  if (from === '*') {
    return '1';
  }
  if (to === '*') {
    return `> ${Number(from)} (${count})`;
  }
  if (from.toLowerCase().includes('varies')) {
    return `${from} (${count})`;
  }
  return `${Number(from)} to ${Number(to)} (${count})`;
};

export const createFilterLabel = (value: string, count: number | undefined) => {
  return count || count == 0 ? `${value} (${count})` : `${value}`;
};

export const createDateLabel = (value: string, count: number | undefined) =>
  count || count == 0
    ? `${formatDate(new Date(parseInt(value)))} (${count})`
    : `${formatDate(new Date(parseInt(value)))}`;

export const brandLabel = (brandName: string, count: number) => `${brandName.toUpperCase()} (${count})`;

//checkbox labels
export const renderFilterLabel = (facet: string, value: string, count: number) => {
  if (facet.toLowerCase().includes('date')) {
    return createDateLabel(value, count);
  }
  if (facet.includes('Range')) {
    if (facet.toLowerCase().includes('price')) {
      return createPriceFilterLabel(value, count);
    }
    if (facet === 'VelocityRange') {
      return createVelocityFilterLabel(value, count);
    }
    if (facet === 'RatingRange') {
      return createRatingFilterLabel(value, count);
    }
    if (facet === 'ProjectileWeightRange' || facet === 'AmmoWeightRange') {
      return createWeightFilterLabel(value, count);
    }
  }
  if (facet === 'ProductStatus') {
    if (value === 'in-stock') {
      return createFilterLabel('Show in Stock Only', count);
    }
  }
  return createFilterLabel(value, count);
};

//selected labels
export const renderSelectedLabel = (facet: string, value: string) => {
  if (facet === 'releaseDate') {
    return createDateLabel(value, undefined);
  }
  if (facet.toLowerCase().includes('price')) {
    return `Price - ${createPriceRangeLabel(value)}`;
  }
  if (facet.includes('Range')) {
    if (facet === 'RatingRange') {
      return `Rating - ${createSelectedRatingLabel(value)}`;
    }
    if (facet === 'VelocityRange') {
      return `Velocity - ${createSelectedVelocityLabel(value)}`;
    }
    if (facet === 'ProjectileWeightRange') {
      return `Projectile Weight - ${createSelectedWeightLabel(value)}`;
    }
    if (facet === 'AmmoWeightRange') {
      return `Ammo Weight - ${createSelectedWeightLabel(value)}`;
    }
  }
  if (facet.includes('ProductStatus')) {
    return 'Products in stock only';
  }
  if (facet === 'product_brand') {
    return `Brand - ${createFilterLabel(value, undefined)}`;
  }
  return `${createFilterTitle(facet)} - ${createFilterLabel(value, undefined)}`;
};
